export default "__VITE_ASSET__Bwn3i6N4__"